import { FormDatePicker, FormFieldGroup, FormGroup, FormLabel, FormSelect, Text } from '$components'
import { FolderTagIcon } from '$components'
import { Input } from './schema'
import { useRescheduleAppointmentForm } from '.'
import { AvailableSlots } from './available-slots'
import { AppointmentMetadata } from './metadata'
import { useInfiniteServiceOptions } from '$hooks/use-infinite-service-options'
import dayjs from 'dayjs'

export function RescheduleAppointmentFormContent() {
  const { defaultValues } = useRescheduleAppointmentForm()
  const serviceOptions = useInfiniteServiceOptions()
  const groomer = defaultValues![Input.Groomer]!

  return (
    <div className="flex flex-col gap-stack-section h-full">
      <FormGroup label="Current Appointment">
        <div className="p-stack-section bg-surface-muted rounded-card-sm">
          <Text
            weight="medium"
            className="mb-stack-dense text-fg-muted"
          >
            {dayjs(defaultValues![Input.StartAt]).format('dddd, MMMM D, YYYY')}
          </Text>

          <Text type="s">
            {dayjs(defaultValues![Input.StartAt]).format('h:mm A')} - {dayjs(defaultValues![Input.FinishAt]).format('h:mm A')} with {groomer.first_name} {groomer.last_name}
          </Text>
        </div>
      </FormGroup>

      <FormGroup label="Service Information">
        <FormFieldGroup>
          <FormLabel htmlFor={Input.Services}>
            Services
          </FormLabel>

          <FormSelect
            name={Input.Services}
            placeholder="Select the services"
            icon={FolderTagIcon}
            multiple
            {...serviceOptions}
          />
        </FormFieldGroup>
      </FormGroup>

      <FormGroup label="Reschedule Options">
        <FormFieldGroup>
          <FormLabel htmlFor={Input.Date}>
            New Date
          </FormLabel>
          <FormDatePicker
            name={Input.Date}
            min={dayjs()}
          />
        </FormFieldGroup>
      </FormGroup>

      <AppointmentMetadata />

      <div className="flex flex-col">
        <div className="flex items-center justify-between gap-stack-tight mb-stack">
          <Text
            as="h2"
            type="s"
          >
            Available Time Slots
          </Text>
        </div>

        <AvailableSlots />
      </div>
    </div>
  )
}
